import React, { useState } from 'react';
import ReactDOM from 'react-dom';

import { ModalOverlay } from 'app/components/Modal/styled';
import { AnimatePresence } from 'framer-motion';

import { POLICIES_TEXT } from './policies-text';
import {
  PoliciesModalBody,
  PoliciesModalButton,
  PoliciesModalButtonsContainer,
  PoliciesModalCancelButton,
  PoliciesModalCheckbox,
  PoliciesModalCheckboxLabel,
  PoliciesModalCloseButton,
  PoliciesModalContent,
  PoliciesModalTextContainer,
  PoliciesModalTextContent,
  PoliciesModalTitle,
  PoliciesModalViewLink,
} from './styled';

interface BD100PoliciesModalProps {
  onAccept: () => void;
  onClose: () => void;
  readOnly?: boolean;
}

const collapsedLayout = { width: '90vw', maxWidth: 560 };
const expandedLayout = { width: '90vw', maxWidth: 900 };

export default function BD100PoliciesModal({
  onAccept,
  onClose,
  readOnly,
}: BD100PoliciesModalProps) {
  const [confirmed, setConfirmed] = useState(false);
  const [expanded, setExpanded] = useState(!!readOnly);

  return ReactDOM.createPortal(
    <ModalOverlay onClick={readOnly ? onClose : undefined}>
      <PoliciesModalContent
        layout
        animate={expanded ? expandedLayout : collapsedLayout}
        initial={readOnly ? expandedLayout : collapsedLayout}
        transition={{ duration: 0.35, ease: [0.4, 0, 0.2, 1] }}
        onClick={(e) => e.stopPropagation()}
      >
        {readOnly ? (
          <PoliciesModalCloseButton onClick={onClose} aria-label="Close">
            &#x2715;
          </PoliciesModalCloseButton>
        ) : null}
        <PoliciesModalTitle>Acceptable Use Policy</PoliciesModalTitle>
        {!readOnly ? (
          <PoliciesModalBody>
            Please review and agree to the acceptable use policy before accessing the Opportunity
            Dashboard.
          </PoliciesModalBody>
        ) : null}
        {!readOnly ? (
          <PoliciesModalViewLink onClick={() => setExpanded((prev) => !prev)}>
            {expanded ? 'Hide Acceptable Use Policy' : 'View Acceptable Use Policy'}
          </PoliciesModalViewLink>
        ) : null}
        <AnimatePresence initial={readOnly}>
          {expanded ? (
            <PoliciesModalTextContainer
              key="policy-text"
              initial={readOnly ? { height: 'auto', opacity: 1 } : { height: 0, opacity: 0 }}
              animate={{ height: 'auto', opacity: 1 }}
              exit={{ height: 0, opacity: 0 }}
              transition={{ duration: 0.35, ease: [0.4, 0, 0.2, 1] }}
            >
              <PoliciesModalTextContent dangerouslySetInnerHTML={{ __html: POLICIES_TEXT }} />
            </PoliciesModalTextContainer>
          ) : null}
        </AnimatePresence>
        {!readOnly ? (
          <>
            <PoliciesModalCheckboxLabel>
              <PoliciesModalCheckbox
                type="checkbox"
                checked={confirmed}
                onChange={(e) => setConfirmed(e.target.checked)}
              />
              I have read and agree to the Acceptable Use Policy
            </PoliciesModalCheckboxLabel>
            <PoliciesModalButtonsContainer>
              <PoliciesModalButton disabled={!confirmed} onClick={onAccept}>
                Accept
              </PoliciesModalButton>
              <PoliciesModalCancelButton onClick={onClose}>Cancel</PoliciesModalCancelButton>
            </PoliciesModalButtonsContainer>
          </>
        ) : null}
      </PoliciesModalContent>
    </ModalOverlay>,
    document.getElementById('root')
  );
}
